import { useEffect, useState } from "react"
import BotzappingForm from "../components/BotzappingForm"
import InstallTag from "../components/InstallTag"
import InstallTrackingCode from "../components/InstallTrackingCode"
import SVGS from "../components/svgs/SVGS"
import Whitelist from "../components/Whitlisting"
import FormService from "../services/formService"
import tracker from "../services/tracker"

const initialSettingsState = {
  whitelist: [],
  maxWhitelistLength: 0,
}

const InstallationForm = () => {
  const { getSettings } = new FormService()
  const [initSettings, setInitSettings] = useState(initialSettingsState)
  // eslint-disable-next-line no-undef
  window.cheqEssential =
    // eslint-disable-next-line no-undef
    typeof ajax_obj != "undefined" ? ajax_obj?.cheq_essential : true
  const { LogoSVG, StripsSVG, CheqEssentialLogoSVG } = SVGS()

  useEffect(() => {
    async function setSettings() {
      const res = await getSettings()
      if (res?.data?.settings) {
        tracker.init(res.data.settings.clientId)
        setInitSettings(res?.data?.settings)
      }
    }
    setSettings()
    // eslint-disable-next-line
  }, [])

  return (
    <div className="content">
      {!window.cheqEssential && (
        <header className="main-header">
          <LogoSVG></LogoSVG>
          <StripsSVG></StripsSVG>
        </header>
      )}
      {window.cheqEssential && (
        <header className="main-header cheq-essential-header">
          <CheqEssentialLogoSVG></CheqEssentialLogoSVG>
        </header>
      )}
      {window.cheqEssential && <InstallTag initSettings={initSettings} />}
      {!window.cheqEssential && <BotzappingForm initSettings={initSettings} />}
      <Whitelist
        list={initSettings.whitelist}
        maxLength={initSettings.maxWhitelistLength}
      />
      {!window.cheqEssential && (
        <InstallTrackingCode initSettings={initSettings} />
      )}
    </div>
  )
}

export default InstallationForm
